class TipoDestinacaoController extends AbstractController
  @$inject = ['$injector', 'pathService', 'api', 'estadoService']

  constructor: (@injector, @pathService, @api, @estadoService) ->
    super(@injector)

    @filtro = {}
    @pagination =
      page: 1
      perPage: 1
      totalPages: 0

    @loadingTracker = @promiseTracker()

    modalUrl = "#{@pathService.getViewUrl()}eficiencia-fiscal/view/configuracao/icms/tipo-destinacao/modal.html"
    @modalTipoDestinacao = @openPopup(modalUrl, "tipoDestinacaoModalController as ctrl", null, true)

    @listOfEstado = []
    @estadoService.getList (list) =>
      @listOfEstado = list

    @loadData()

  loadData: (page = 1) ->
    filtro = angular.copy @filtro

    filtro.page = page

    @loadingTracker.addPromise(
      @api
        .get('/icms/tipo-destinacao', filtro)
        .then(({data}) =>
          @listOfData = data.items

          @pagination =
            page: page
            totalPages: data.total_pages
            perPage: 1
        ).catch(() =>
          @Alert.error('Ocorreu um erro ao carregar a listagem.', 'Erro!', false)
        )
    )

  add: ->
    @modalTipoDestinacao(@modalResolve(), @modalCallback())

  edit: (item) ->
    @modalTipoDestinacao(@modalResolve(item), @modalCallback())

  remove: (item)->
    Confirm.warning('Atenção', "Deseja realmente remover o Tipo de destinação Nº <strong>#{item.id}</strong>?", {
      Sim: =>
        @api
          .delete("/icms/tipo-destinacao/#{item.id}")
          .then(=>
            Alert.success("A remoção do Tipo de destinação Nº <strong>#{item.id}</strong> foi realizada com sucesso!", 'Sucesso')
            @loadData()
          )
          .catch(=> Alert.error("Ocorreu um erro ao remover o Tipo de destinação Nº <strong>#{item.id}</strong>."))
      Não: ''
    })

  modalCallback: () ->
    (result) =>
      if result.ok
        @loadData()
      else
        @Alert.warning(result.message, 'Ocorreu um erro', false)


  modalResolve: (tipoDestinacao = {}) -> {
    tipoDestinacao: => angular.copy tipoDestinacao
    listOfEstado: => angular.copy @listOfEstado
  }

angular.module('eficienciaFiscalModule').controller('tipoDestinacaoController', TipoDestinacaoController)

class TipoDestinacaoModalController extends AbstractController
  @$inject = ['$injector', '$scope', '$filter', '$uibModalInstance', 'api', 'tipoDestinacao', 'listOfEstado']

  constructor: ($injector, scope, @filter, @modalInstance, @api, @tipoDestinacao, @listOfEstado) ->
    super($injector)

    @submitTracker = @promiseTracker()
    @tipoDestinacao.estado = @tipoDestinacao.estado?.id

  salvar: (form) ->
    if form.$valid
      [request, url] =

      @submitTracker.addPromise(
        @doRequest()
          .then(=>
            Alert.success("Tipo de destinação #{if @tipoDestinacao.id then 'atualizado' else 'criado'} com sucesso.", 'Sucesso!')
            @modalInstance.close(new Retorno(true))
          )
          .catch(=> Alert.error('Ocorreu um erro ao adicionar um tipo de destinação.', 'Erro!', false))
      )

  doRequest: () ->
    if @tipoDestinacao.id
      @api.put("/icms/tipo-destinacao/#{@tipoDestinacao.id}", {tipo_destinacao: @tipoDestinacao})
    else
      @api.post("/icms/tipo-destinacao", {tipo_destinacao: @tipoDestinacao})

angular.module('eficienciaFiscalModule').controller('tipoDestinacaoModalController', TipoDestinacaoModalController)
